import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Orgimage } from './model/orgimage';
import { OrglogoService } from './service/orglogo.service';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Orgstyle } from '@src/app/helpers/dynamicstyle/model/orgstyle';
import { PersonOrganization } from '../top-nav/model/personorganization';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { ImageCroppedEvent } from 'ngx-image-cropper';


import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orglogo',
  templateUrl: './orglogo.component.html',
  styleUrls: ['./orglogo.component.css']
})
export class OrglogoComponent implements OnInit, OnChanges {
  @Input() useraccount: boolean;
  @Input() showFileDialog: boolean;
  selectedFiles: FileList;
  selectedFileName: string;
  @Input() sidebarlogo: boolean;
  @Input() orgimage: Orgimage;
  @Input() orgId: string;
  @Input() modalchanger: boolean;
  //type can be rect or square
  @Input() imgtype: string;
  uid: string;
  refreshBlock: boolean;
  orgstyle: Orgstyle;
  @Input() whitelabeled: boolean;
  @Input() reset: boolean;

  constructor(
    private orgImageService: OrglogoService,
  ) {
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.orgId && changes.orgId.currentValue) {
      this.orgId = changes.orgId.currentValue;
    }
    if (changes.imgtype && changes.imgtype.currentValue) {
      this.imgtype = changes.imgtype.currentValue;
      //console.log('Img type changed to',this.imgtype);
      if (sessionStorage.getItem('currentOrgLogoUrl-' + this.orgId + '_' + this.imgtype)) {
        this.orgimage = new Orgimage;
        this.orgimage.type = this.imgtype;

        this.orgimage.orgimageurl = sessionStorage.getItem('currentOrgLogoUrl-' + this.orgId + '_' + this.imgtype);


      } else {
        this.refreshUrl();
      }
    }
  }



  ngOnInit() {
    if (!this.orgId) {
      this.orgId = SessionHelper.getChoosenOrg();
    }
    this.refreshBlock = false;
    this.uid = uuid();
    this.orgimage = new Orgimage;
    if (!this.imgtype) {
      const ds = SessionHelper.getDynamicStyle();
      const orgstyle = ds && ds !== 'undefined' ? JSON.parse(ds) : null;
      this.imgtype = orgstyle?.logoformat == 'rectangel' ? 'rect' : 'square';
    }

    this.orgimage.type = this.imgtype;

    function uuid() {
      var uuidValue = "", k, randomValue;
      for (k = 0; k < 32; k++) {
        randomValue = Math.random() * 16 | 0;

        if (k == 8 || k == 12 || k == 16 || k == 20) {
          uuidValue += "-"
        }
        uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
      }
      return uuidValue;
    }
    //console.log('Img type intitally is ',this.imgtype);
    if (sessionStorage.getItem('currentOrgLogoUrl-' + this.orgId + '_' + this.imgtype)) {
      this.orgimage.orgimageurl = sessionStorage.getItem('currentOrgLogoUrl-' + this.orgId + '_' + this.imgtype);
    } else {
      if (this.imgtype) {
        this.refreshUrl();
      }

    }
    //this.refreshUrl();
  }

  refreshUrl() {
    if (!this.refreshBlock && this.orgId && this.imgtype) {
      this.refreshBlock = true;

      //console.log('refresh logo url reached')
      //console.log('refresh logo get image '+this.orgId+'_'+this.imgtype , sessionStorage.getItem('currentOrgLogoUrl-'+this.orgId+'_'+this.imgtype ));
      this.orgImageService.getorgImageDB(this.orgId, this.imgtype).pipe(untilDestroyed(this)).subscribe(pi => {
        if (pi != "No image for this organization.") {
          this.orgimage = pi;

          sessionStorage.setItem('currentOrgLogoUrl-' + this.orgId + '_' + this.imgtype, this.orgimage.orgimageurl);
          this.refreshBlock = false;

        }
      })

    }

  }

  onDocumentSubmit(type: string) {
    var filename = this.orgId + '_' + this.selectedFileName;
    var file = this.base64ToFile(this.croppedImage, filename);
    let orgimage = new Orgimage;
    this.orgImageService.getSignedUploadUrl(filename, this.orgId).pipe(untilDestroyed(this)).subscribe(SignedUploadUrl => {
      //console.log('Signed upload url: '+SignedUploadUrl.url);
      this.orgImageService.addorgImageFile(file, SignedUploadUrl.url).pipe(untilDestroyed(this)).subscribe(resp => {
        //console.log('response from adding file to S3' , resp);
        orgimage.image = SignedUploadUrl.key;
        orgimage.type = type;
        orgimage.organizationId = this.orgId;
        orgimage.date_added = new Date();
        orgimage.orgimageurl = SignedUploadUrl.objectUrl;
        sessionStorage.setItem('currentOrgLogoUrl-' + this.orgId + '_' + type, orgimage.orgimageurl);
        this.orgImageService.addorgImage(orgimage, type).pipe(untilDestroyed(this)).subscribe(pi => {
          if (pi) {
            this.orgimage = pi;
            // this.orgImageService.getorgImageUrl(filename).pipe(untilDestroyed(this)).subscribe(url => {
            //   this.orgimage.orgimageurl = url.url;
            //   sessionStorage.setItem('currentOrgLogoUrl-'+this.orgId+'_'+type , url.url);

            // });
          }
        });
      });
    })

  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperready: boolean;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles.item(0).name;
  }
  imageCropped(event: ImageCroppedEvent) {
    //console.log(event);
    this.croppedImage = event.base64;
  }
  cropperReady() {
    // cropper ready
    this.cropperready = true;
  }
  loadImageFailed() {
    // show message
  }
  base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  logoreset() {
    this.cropperready = false;
    this.selectedFiles = null;
    this.imageChangedEvent = null;
  }
}
